import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _typeof from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { rechargeSourceDetail, rechargeSourceDetailCurrency } from "@/api/dataAll/userSegmentationGrowth";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import * as XLSX from 'xlsx';
export default {
  name: "sevenAverageProductionSales",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      deviceList: [// {
      //   label: "新增设备",
      //   id: "device_id"
      // },
      {
        label: this.$t('newAccountLabel'),
        id: "user"
      }],
      paramsData: {
        dimension_kind: "user"
      },
      tableList: [],
      serverList: [],
      dates: [],
      resourceIds: [],
      exportdataDealoading: false
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    levelChange: function levelChange(e) {
      if (!e) {
        this.paramsData.recharge_levels = '';
      }
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClick: function searchClick() {
      var _this2 = this;

      this.tableList = [];
      this.tableData = [];

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      if (!this.paramsData.source_id) {
        this.$message.error(this.$t('pleaseInputSourceId'));
        return;
      }

      if (this.levelItem == '1' && !this.paramsData.recharge_levels) {
        this.$message.error(this.$t('pleaseInputLevel'));
        return;
      }

      if (/，/.test(this.paramsData.recharge_levels)) {
        this.$message.error(this.$t('pleaseInputEnglishComma'));
        return;
      }

      this.reqLoading = true;
      var params = {
        dimension_kind: this.paramsData.dimension_kind,
        game_id: this.searchData.game_id,
        // special_product_id: this.searchData.special_product_id,
        starttime: this.searchData.starttime,
        endtime: this.searchData.endtime,
        server_id: this.paramsData.server_id,
        recharge_levels: this.paramsData.recharge_levels,
        source_id: this.paramsData.source_id
      }; //判断是否有货币

      var searchCurrency = this.$store.state.d2admin.serchSelect.searchCurrency;
      var reqFn = searchCurrency.length ? rechargeSourceDetailCurrency : rechargeSourceDetail;
      reqFn(params).then(function (res) {
        if (res.code == 200) {
          if (!res.data) {
            return;
          }

          var data = res.data;
          var tier_config = res.tier_config;
          _this2.dates = Object.keys(res.data);
          _this2.resourceIds = _this2.extractResourceIds(res.data); //处理表头

          _this2.tableList = [{
            label: "",
            prop: "recharge_range",
            list: [{
              label: _this2.$t('userLevelLabel'),
              prop: "recharge_range",
              list: []
            }]
          }];

          var _loop = function _loop(date) {
            var dateItem = {
              label: date,
              prop: date,
              list: []
            }; // 添加第一天，第二天....

            var _loop3 = function _loop3(day) {
              var dayItem = {
                label: _this2.$t('dayN', {
                  n: day
                }),
                prop: "".concat(date, "-").concat(day),
                list: []
              }; // 添加分层人数

              dayItem.list.push({
                label: _this2.$t('payPeopleCount'),
                prop: "".concat(date, "-").concat(day, "-user_count"),
                list: []
              }); // 添加资源列（动态获取所有资源ID）

              var resourceIds = _this2.resourceIds;
              resourceIds.forEach(function (resourceId) {
                // 资源平均产出
                dayItem.list.push({
                  label: "".concat(_this2.$t('resourcePrefix')).concat(resourceId).concat(_this2.$t('resourceAvgProduce')),
                  labelParts: [_this2.$t('resourcePrefix'), resourceId, _this2.$t('resourceAvgProduce')],
                  prop: "".concat(date, "-").concat(day, "-").concat(resourceId, "-produce_avg"),
                  list: []
                }); // 资源平均消耗

                dayItem.list.push({
                  label: "".concat(_this2.$t('resourcePrefix')).concat(resourceId).concat(_this2.$t('resourceAvgConsume')),
                  labelParts: [_this2.$t('resourcePrefix'), resourceId, _this2.$t('resourceAvgConsume')],
                  prop: "".concat(date, "-").concat(day, "-").concat(resourceId, "-consume_avg"),
                  list: []
                });
              });
              dateItem.list.push(dayItem);
            };

            for (var day = 1; day <= 7; day++) {
              _loop3(day);
            }

            _this2.tableList.push(dateItem);
          };

          for (var date in data) {
            _loop(date);
          } // 初始化 tableData - 为每个层级创建一个对象


          _this2.tableData = Object.keys(res.tier_config).map(function (level) {
            var rowData = {
              "recharge_range": res.tier_config[level].label
            }; // 为每个日期和天数添加数据

            _this2.dates.forEach(function (date) {
              var _loop2 = function _loop2(day) {
                var dayData = res.data[date] && res.data[date][day.toString()];

                if (dayData && dayData[level]) {
                  var levelData = dayData[level]; // 添加用户数

                  rowData["".concat(date, "-").concat(day, "-user_count")] = levelData.user_count || 0; // 添加资源数据

                  _this2.resourceIds.forEach(function (resourceId) {
                    if (levelData.resources && levelData.resources[resourceId]) {
                      rowData["".concat(date, "-").concat(day, "-").concat(resourceId, "-produce_avg")] = levelData.resources[resourceId].produce_avg || 0;
                      rowData["".concat(date, "-").concat(day, "-").concat(resourceId, "-consume_avg")] = levelData.resources[resourceId].consume_avg || 0;
                    } else {
                      rowData["".concat(date, "-").concat(day, "-").concat(resourceId, "-produce_avg")] = 0;
                      rowData["".concat(date, "-").concat(day, "-").concat(resourceId, "-consume_avg")] = 0;
                    }
                  });
                } else {
                  // 没有数据时设为0
                  rowData["".concat(date, "-").concat(day, "_user_count")] = 0;

                  _this2.resourceIds.forEach(function (resourceId) {
                    rowData["".concat(date, "-").concat(day, "-").concat(resourceId, "-produce_avg")] = 0;
                    rowData["".concat(date, "-").concat(day, "-").concat(resourceId, "-consume_avg")] = 0;
                  });
                }
              };

              for (var day = 1; day <= 7; day++) {
                _loop2(day);
              }
            });

            return rowData;
          });
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    // 提取所有资源ID
    extractResourceIds: function extractResourceIds(data) {
      var resourceIds = new Set(); // 遍历所有日期和天数

      for (var _i = 0, _Object$keys = Object.keys(data); _i < _Object$keys.length; _i++) {
        var date = _Object$keys[_i];

        for (var day = 1; day <= 7; day++) {
          var dayData = data[date][day.toString()];

          if (dayData) {
            // 遍历所有层级
            for (var _i2 = 0, _Object$keys2 = Object.keys(dayData); _i2 < _Object$keys2.length; _i2++) {
              var level = _Object$keys2[_i2];
              var resources = dayData[level].resources;

              if (resources && _typeof(resources) === 'object') {
                // 添加资源ID
                Object.keys(resources).forEach(function (id) {
                  return resourceIds.add(id);
                });
              }
            }
          }
        }
      }

      return Array.from(resourceIds);
    },
    exportdata: function exportdata() {
      this.exportdataDealoading = true; // 1. 构建三级表头 & 收集数据字段

      var headers = [[], [], []]; // 三级表头

      var dataKeys = []; // 对应的数据字段名（prop）
      // 第一列：用户层级

      headers[0].push("");
      headers[1].push("");
      headers[2].push(this.$t('userLevelLabel'));
      dataKeys.push("recharge_range"); // 遍历 tableList 构建三级结构

      var dateColSpan = {}; // 记录每个日期占多少列

      this.tableList.slice(1).forEach(function (dateGroup) {
        var _dateGroup$list$;

        var dateLabel = dateGroup.label; // "2025-07-30"

        var dayCount = dateGroup.list.length;
        var fieldPerDay = ((_dateGroup$list$ = dateGroup.list[0]) === null || _dateGroup$list$ === void 0 ? void 0 : _dateGroup$list$.list.length) || 0;
        var totalSpan = dayCount * fieldPerDay; // 第一级表头：日期（跨列）

        headers[0].push(dateLabel); // 占位空列

        for (var i = 1; i < totalSpan; i++) {
          headers[0].push("");
        } // 第二级 & 第三级：遍历每一天的每一个字段


        dateGroup.list.forEach(function (day) {
          var dayLabel = day.label; // "第一天"

          var fieldCount = day.list.length; // 第二级：天数（跨 fieldCount 列）

          headers[1].push(dayLabel);

          for (var _i3 = 1; _i3 < fieldCount; _i3++) {
            headers[1].push("");
          } // 第三级：指标名称 + 收集数据 key


          day.list.forEach(function (field) {
            headers[2].push(field.label);
            dataKeys.push(field.prop);
          });
        });
        dateColSpan[dateLabel] = totalSpan;
      }); // 2. 构建数据行

      var dataRows = this.tableData.map(function (row) {
        return dataKeys.map(function (key) {
          var val = row[key];
          return val == null ? '' : val;
        });
      }); // 3. 合并表头数组

      var worksheetData = [].concat(headers, _toConsumableArray(dataRows)); // 4. 创建工作表

      var worksheet = XLSX.utils.aoa_to_sheet(worksheetData); // 5. 设置列宽（可选）

      var colWidths = worksheetData[2] ? worksheetData[2].map(function (h) {
        return {
          wch: Math.max(6, h.toString().length * 1.2)
        };
      }) : [];
      worksheet['!cols'] = colWidths; // 6. 设置表头合并

      var merges = [];
      var colIndex = 1; // 从第2列开始（第1列是"用户层级"）

      this.tableList.slice(1).forEach(function (dateGroup) {
        var _dateGroup$list$2;

        var dateLabel = dateGroup.label;
        var dayCount = dateGroup.list.length;
        var fieldPerDay = ((_dateGroup$list$2 = dateGroup.list[0]) === null || _dateGroup$list$2 === void 0 ? void 0 : _dateGroup$list$2.list.length) || 0;
        var totalSpan = dayCount * fieldPerDay; // 合并第一级：日期（行0，跨列）

        merges.push({
          s: {
            r: 0,
            c: colIndex
          },
          // start
          e: {
            r: 0,
            c: colIndex + totalSpan - 1
          } // end

        }); // 合并第二级：每一天的 label（行1）

        var dayCol = colIndex;
        dateGroup.list.forEach(function (day) {
          var fieldCount = day.list.length;

          if (fieldCount > 1) {
            merges.push({
              s: {
                r: 1,
                c: dayCol
              },
              e: {
                r: 1,
                c: dayCol + fieldCount - 1
              }
            });
          }

          dayCol += fieldCount;
        });
        colIndex += totalSpan;
      }); // 应用合并

      worksheet['!merges'] = merges; // 7. 创建工作簿并导出

      var workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, this.$t('threeLevelHeaderReport'));
      XLSX.writeFile(workbook, "".concat(this.$route.meta.title, ".xlsx"));
      this.exportdataDealoading = false;
    }
  }
};